// @ts-nocheck
import { BigNumber } from "ethers";
import { ReactNode, useEffect, useState } from "react";
import styled from "styled-components/macro";
import { useTokenURI } from "../../hooks/useDoubleDownClub";
import DDCDropdown from "../Dropdown/DDCDropdown";

const InputPanel = styled.div<{ hideInput?: boolean }>`
    ${({ theme }) => theme.flexColumnNoWrap}
    width: 100%;
    position: relative;
    border: none;
    border-radius: ${({ hideInput }) => (hideInput ? '16px' : '20px')};
    background-color: ${({ theme, hideInput }) => (hideInput ? 'transparent' : 'transparent')};
    z-index: 1;
    width: ${({ hideInput }) => (hideInput ? '100%' : 'initial')};
    transition: height 1s ease;
    will-change: height;
`

const Container = styled.div`
    border-radius: 16px;
    background-color: transparent;
    width: 100%;
    :focus,
    :hover {
    }
  `

const InputRow = styled.div<{ selected: boolean }>`
    ${({ theme }) => theme.flexRowNoWrap}
    align-items: center;
    justify-content: space-between;
    padding: ${({ selected }) => (selected ? ' 1rem 1rem 0.75rem 1rem' : '1rem 1rem 1rem 1rem')};
    padding: 0px;
    padding-left: 0px;
    padding-top: 0px;
`

interface DDCTokenProps {
    value: string
    onUserInput: (value: string) => void
    onMax?: () => void
    label?: ReactNode
    items: BigNumber[]
    onItemSelect: (item: NFTItem) => void
    nftItem?: NFTItem | null
    id: string
    loading?: boolean
    disabled?: boolean
    approved?: boolean
}

export type NFTItem = {
    id: number;
    logo: any;
}

export default function DDCTokenSelection({
    value,
    onUserInput,
    onMax,
    onItemSelect,
    nftItem,
    items,
    id,
    loading = false,
    disabled = false,
    approved,
    ...rest
}: DDCTokenProps) {
    const [selectedItem, setSelectedItem] = useState<NFTItem | undefined>()
    const { images } = useTokenURI(items);
    const [nftItems, setNftItems] = useState([]);

    useEffect(() => {
        if (nftItem) {
            setSelectedItem(nftItem)
        } else {
            setSelectedItem(undefined)
        }
    }, [nftItem])

    useEffect(() => {
        (async () => {
            const resp = [];
            if(images?.length > 0) {
                for(let i = 0 ; i < images.length ; i ++) {
                    if(images[i]?.result !== undefined) {
                        const base64Str = images[i]?.result[0];
                        const json = atob(base64Str.substring(29));
                        const result = JSON.parse(json.substring(1));
                        resp.push({
                            id : parseInt(items[i]),
                            logo: result.image
                        })
                    }
                }
                setNftItems(resp);
            } else {
                setNftItems([]);
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [images])

    return (
        <InputPanel id={id} {...rest} style={{ width: '100%' }}>
            <Container>
                <InputRow style={{ padding: '0', borderRadius: '8px' }} selected={!onItemSelect}>
                    <DDCDropdown
                        onUserClick={onItemSelect}
                        disabled={disabled}
                        selected={selectedItem}
                        items={nftItems}
                    >
                        <div>{JSON.stringify(selectedItem)}</div>
                    </DDCDropdown>
                </InputRow>
            </Container>
        </InputPanel>
    )
}
